import { AiOutlinePlus } from 'react-icons/ai';
import { Link } from 'react-router-dom';
import { FilterIcon } from '../../../../../assets/svg/filter';
import { SortIcon } from '../../../../../assets/svg/sort';
import { Button } from '../../../../../components/button/button';
import { DropdownFilter } from '../../../../../features/dropdown-filter/dropdown-filter';
import { DropdownSorter } from '../../../../../features/dropdown-sorter/dropdown-sorter';
import { DropdownStyleView } from '../../../../../features/dropdown-style-view/dropdown-style-view';
import { HasAccess } from '../../../../../features/has-access/has-access';
import { concatPath } from '../../../../../helpers/path';
import { useLang } from '../../../../../hooks/use-lang';
import { ManagerPath, PromotionPath, RootPath } from '../../../../../routes/manager/manager-enums';
import { promoStatusMap, PromoStatusType } from '../../../../../store/api/promotion-api';
import s from './promo-controls.module.css';

export const PromoControls = () => {
  const { t } = useLang();

  return (
    <div className={s.feature}>
      <DropdownStyleView />
      <DropdownSorter
        label={t('Сортировка')}
        leftIcon={<SortIcon />}
        options={[
          { label: t('Новые'), value: 'active_from', dir: 'asc' },
          { label: t('Старые'), value: 'active_from', dir: 'desc' },
        ]}
      />
      <DropdownFilter
        label={t('Фильтр')}
        leftIcon={<FilterIcon />}
        options={[
          {
            label: t('По названию'),
            value: 'name',
            filter: 'input',
          },
          {
            label: t('По описанию'),
            value: 'description',
            filter: 'input',
          },

          {
            label: t('По статусу'),
            value: 'status',
            filter: 'multi-select',
            filterOptions: Object.keys(promoStatusMap).map((key) => ({
              id: key,
              value: t(promoStatusMap[key as PromoStatusType]),
            })),
          },
        ]}
      />

      <HasAccess service="promotion" permissions={['write']}>
        <div className={s.controls}>
          <Link
            to={concatPath([RootPath.Manager, ManagerPath.Promotion, PromotionPath.Create])}
            data-testid="add-promo-button"
          >
            <Button fullWidth size="lg">
              <AiOutlinePlus />
              <span className="hide__M"> {t('Создать акцию')}</span>
            </Button>
          </Link>
        </div>
      </HasAccess>
    </div>
  );
};
